/* Kopstorm · TØTE set pricing in the cart drawer
   - [data-kv-set-add] buttons add one unit with a marker property and re-render the drawer
   - gift sync: adds the gift product (property _kv_bundle_gift) once the cart holds
     data-gift-at bag units, removes it below that, caps it at one unit.
     The price itself is set by the kv-tote-set-pricing discount.
   Active when the root is in live mode, or in test mode with html[data-kv-set="on"] (Kopstorm drawer)
   or html[data-kv-set="v2"] (TØTE drawer). ?kv_set=on|v2|off sets it for QA, kept for the session. */
(function () {
  'use strict';
  if (window.__kvSetCart) return;
  window.__kvSetCart = true;

  (function qa() {
    var m = /[?&]kv_set=(on|v2|off)\b/.exec(window.location.search);
    var v = null;
    try {
      if (m) window.sessionStorage.setItem('kvSetArm', m[1]);
      v = window.sessionStorage.getItem('kvSetArm');
    } catch (e) { v = m ? m[1] : null; }
    if (v === 'off') document.documentElement.removeAttribute('data-kv-set');
    else if (v) document.documentElement.setAttribute('data-kv-set', v);
  })();

  var DECLINED = 'kvSetGiftDeclined';
  var busy = false;
  var ops = [];

  function store(get, val) {
    try {
      if (get) return window.sessionStorage.getItem(DECLINED) === '1';
      if (val) window.sessionStorage.setItem(DECLINED, '1'); else window.sessionStorage.removeItem(DECLINED);
    } catch (e) { return false; }
    return false;
  }

  function root() { return document.querySelector('[data-kv-set-root]'); }
  function active(r) {
    if (!r) return false;
    var arm = document.documentElement.getAttribute('data-kv-set');
    return r.dataset.mode === 'live' || arm === 'on' || arm === 'v2';
  }

  function drawer() { return document.querySelector('cart-drawer'); }

  function post(url, body) {
    var d = drawer();
    if (d && d.getSectionsToRender) {
      body.sections = d.getSectionsToRender().map(function (s) { return s.id; });
      body.sections_url = window.location.pathname;
    }
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) { return r.json(); }).then(function (res) {
      if (res && !res.status && d && d.renderContents && res.sections) {
        d.renderContents(res);
        d.classList.remove('is-empty');
      }
      fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
        document.dispatchEvent(new CustomEvent('cart:change', { detail: { cart: cart } }));
      }).catch(function () {});
      return res;
    });
  }

  /* Add buttons (card and second colour) */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-kv-set-add]');
    if (!btn) return;
    e.preventDefault();
    if (btn.classList.contains('loading') || btn.classList.contains('is-loading')) return;
    btn.classList.add(btn.classList.contains('kv-set-line__swatch') ? 'is-loading' : 'loading');
    var props = {};
    props[btn.dataset.kvSetProp || '_kv_bundle_addon'] = 'cart';
    post('/cart/add.js', { items: [{ id: Number(btn.dataset.kvSetAdd), quantity: 1, properties: props }] })
      .catch(function () {})
      .then(function () { btn.classList.remove('loading', 'is-loading'); });
  });

  /* A shopper who removes the gift keeps it removed for the session */
  document.addEventListener('click', function (e) {
    var rm = e.target.closest('.kv-set-giftline cart-remove-button, .kv-set-giftline cart-remove-button button');
    if (rm) store(false, true);
  }, true);

  function sync() {
    var r = root();
    if (!active(r) || busy) return;
    if (r.dataset.kvSetDone === '1') return; /* this state was already acted on; wait for the re-render */
    var bags = parseInt(r.dataset.bags, 10) || 0;
    var at = parseInt(r.dataset.giftAt, 10) || 0;
    var variant = r.dataset.giftVariant;
    var key = r.dataset.giftKey;
    var qty = parseInt(r.dataset.giftQty, 10) || 0;
    if (!at) return;

    if (bags < at) store(false, false);

    var now = Date.now();
    ops = ops.filter(function (t) { return now - t < 8000; });
    if (ops.length >= 3) return; /* loop guard */

    var job = null;
    if (key && bags < at) {
      job = post('/cart/change.js', { id: key, quantity: 0 });
    } else if (key && qty > 1) {
      job = post('/cart/change.js', { id: key, quantity: 1 });
    } else if (!key && variant && bags >= at && !store(true)) {
      job = post('/cart/add.js', { items: [{ id: Number(variant), quantity: 1, properties: { _kv_bundle_gift: '1' } }] });
    }
    if (!job) return;
    busy = true;
    r.dataset.kvSetDone = '1';
    ops.push(now);
    job.catch(function () {}).then(function () { busy = false; });
  }


  /* Progress bars: animate every track from its previous fill to the new one after each drawer render */
  var seen = window.WeakSet ? new WeakSet() : null;
  function animateTrack(track) {
    if (!seen || seen.has(track)) return;
    seen.add(track);
    var key = 'kvSetFill:' + (track.dataset.kvFillKey || 'track');
    var target = parseFloat(track.dataset.fill) || 0;
    var prev = null;
    try { prev = window.sessionStorage.getItem(key); } catch (e) {}
    try { window.sessionStorage.setItem(key, String(target)); } catch (e) {}
    if (prev === null) return;
    prev = parseFloat(prev) || 0;
    if (prev === target) return;
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    track.style.setProperty('--kv-fill', prev + '%');
    void track.offsetWidth;
    requestAnimationFrame(function () { track.style.setProperty('--kv-fill', target + '%'); });
  }
  function animateBar() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-kv-set-bar] .kv-set-bar__track'), animateTrack);
  }


  /* Second-bag block: switch between bag families */
  function setTab(line, idx) {
    Array.prototype.forEach.call(line.querySelectorAll('[data-kv-set-tab]'), function (t) {
      t.setAttribute('aria-selected', t.dataset.kvSetTab === String(idx) ? 'true' : 'false');
    });
    var tabs = line.querySelector('.kv-set-line__tabs');
    if (tabs) tabs.style.setProperty('--kv-tab', String(idx));
    Array.prototype.forEach.call(line.querySelectorAll('[data-kv-set-panel]'), function (p) {
      p.hidden = p.dataset.kvSetPanel !== String(idx);
      var row = p.querySelector('[data-kv-set-row]');
      if (row && !p.hidden) updateRail(row);
    });
  }
  function updateRail(row) {
    var max = row.scrollWidth - row.clientWidth;
    var scrollable = max > 2;
    var x = row.scrollLeft;
    row.classList.toggle('is-scroll', scrollable);
    row.classList.toggle('is-start', scrollable && x <= 2);
    row.classList.toggle('is-end', scrollable && x >= max - 2);
    row.classList.toggle('is-mid', scrollable && x > 2 && x < max - 2);
    var rail = row.parentNode;
    var prev = rail.querySelector('.kv-set-line__arrow--prev');
    var next = rail.querySelector('.kv-set-line__arrow--next');
    if (prev) prev.hidden = !scrollable || x <= 2;
    if (next) next.hidden = !scrollable || x >= max - 2;
  }
  document.addEventListener('scroll', function (e) {
    if (e.target && e.target.matches && e.target.matches('[data-kv-set-row]')) updateRail(e.target);
  }, true);
  document.addEventListener('click', function (e) {
    var a = e.target.closest('[data-kv-set-scroll]');
    if (!a) return;
    e.preventDefault();
    var row = a.parentNode.querySelector('[data-kv-set-row]');
    if (row) row.scrollBy({ left: parseInt(a.dataset.kvSetScroll, 10) * row.clientWidth * 0.8, behavior: 'smooth' });
  });
  window.addEventListener('resize', function () {
    Array.prototype.forEach.call(document.querySelectorAll('[data-kv-set-row]'), updateRail);
  });
  function initLines() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-kv-set-line]'), function (line) {
      if (line.dataset.kvReady) return;
      line.dataset.kvReady = '1';
      setTab(line, line.dataset.active || '0');
    });
  }
  document.addEventListener('click', function (e) {
    var t = e.target.closest('[data-kv-set-tab]');
    if (!t) return;
    e.preventDefault();
    setTab(t.closest('[data-kv-set-line]'), t.dataset.kvSetTab);
  });

  var timer = null;
  function schedule() { clearTimeout(timer); timer = setTimeout(sync, 150); }

  function watch() {
    var d = drawer();
    if (d && window.MutationObserver) {
      new MutationObserver(function () { initLines(); animateBar(); schedule(); }).observe(d, { childList: true, subtree: true });
    }
    initLines();
    animateBar();
    schedule();
  }

  document.addEventListener('cart:change', schedule);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', watch);
  else watch();
})();
